import React, { createContext, useContext, useCallback, useRef, useState } from 'react';

// Ponte entre a Navbar (dona do estado/abertura do menu lateral, hoje um
// ícone posicionado de forma independente na tela) e os cabeçalhos de cada
// página (HeaderV2 / GenericUpper), que agora renderizam o próprio ícone de
// hambúrguer dentro da mesma linha do título/botão de plano. A Navbar
// registra a função que abre o menu; os cabeçalhos chamam essa função e
// avisam que já existe um hambúrguer "inline" pra Navbar não desenhar o
// dela (evitando ícone duplicado).
const HeaderMenuContext = createContext();

export const HeaderMenuProvider = ({ children }) => {
  const openHandlerRef = useRef(null);
  const [hasInlineMenuButton, setHasInlineMenuButton] = useState(false);

  const registerMenuOpenHandler = useCallback((fn) => {
    openHandlerRef.current = fn;
  }, []);

  const openMenu = useCallback(() => {
    if (typeof openHandlerRef.current === 'function') {
      openHandlerRef.current();
    }
  }, []);

  return (
    <HeaderMenuContext.Provider
      value={{ registerMenuOpenHandler, openMenu, hasInlineMenuButton, setHasInlineMenuButton }}
    >
      {children}
    </HeaderMenuContext.Provider>
  );
};

export const useHeaderMenu = () => {
  const context = useContext(HeaderMenuContext);
  if (!context) {
    throw new Error('useHeaderMenu must be used within a HeaderMenuProvider');
  }
  return context;
};
